export const allowedUrlParamToQuestionDescription: Record<string, string> = {
    login: 'LOGIN',
    radicado: 'RADICADO',
    numeroDocumento: 'NÚMERO DE DOCUMENTO PETICIONARIO',
    telefonoMovil: 'TELÉFONO MOVIL',
};

export const isRequiredAnswerComplete = (
    type: string,
    answerData: { answer?: unknown; error?: boolean } | undefined
): boolean => {
    if (!answerData || answerData.error) return false;

    const answer = answerData.answer;

    switch (type) {
        case 'multiple':
            return Array.isArray(answer) && answer.length > 0;
        case 'linear':
            return answer !== '' && answer !== null && answer !== undefined;
        case 'only':
        case 'list-only':
        case 'linear-label':
            return typeof answer === 'string' && answer.length > 0;
        case 'text':
        case 'open-text':
        case 'validation-reference':
            return typeof answer === 'string' && answer.trim().length > 0;
        default:
            return answer !== '' && answer !== null && answer !== undefined;
    }
};
